import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "-FilterSDGs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode("関連するSDGs"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "u-spOnly",
    id: "js-checkedSDGsValue"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "u-arrow-spOnlyBottom js-accordionArrow" })
], -1)
const _hoisted_3 = ["id", "value", "lval"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "sdgs_goal u-spOnly" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "sdgs_goal u-pcOnly" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dl", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("dd", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsSDGs, (dataSd, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("input", {
              id: "SDGs_"+dataSd.value,
              type: "checkbox",
              value: dataSd.value,
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
              name: "Sd",
              lval: `${dataSd.value}`
            }, null, 40, _hoisted_3),
            _createElementVNode("label", {
              class: _normalizeClass(["SDGs_icon", "SDGs_icon"+dataSd.value]),
              for: "SDGs_"+dataSd.value
            }, null, 10, _hoisted_4)
          ], 64))
        }), 128)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
          return _createElementVNode("div", {
            class: "sdgs_hidden u-pcOnly",
            key: n
          })
        }), 64)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: `${_ctx.consts.telemail}shingaku/p/sdgs_kaisetu/`,
            target: "_blank"
          }, "SDGs 17ゴール解説", 8, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("a", {
        href: `${_ctx.consts.telemail}shingaku/p/sdgs_kaisetu/`,
        target: "_blank"
      }, "SDGs 17ゴール解説", 8, _hoisted_8)
    ])
  ], 64))
}